import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bar",
  "use": "icon-bar-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bar\"><defs><style type=\"text/css\"></style></defs><path d=\"M298.666667 768h554.666666v85.333333H213.333333V213.333333h85.333334v554.666667zM341.333333 298.666667h85.333334v426.666666H341.333333V298.666667z m128 85.333333h85.333334v341.333333h-85.333334V384z m128 85.333333h85.333334v256h-85.333334v-256z m128 85.333334h85.333334v170.666666h-85.333334v-170.666666z\" p-id=\"2979\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol